import React, { useState, useRef } from 'react';
import { Form, Row, Col, Button, Alert } from 'react-bootstrap';
import '../../assets/css/stylesheets/components/form/ContactForm.css';
import * as API from '../../lib/JerseyDirectoryAPI';

function ContactForm() {
    const [emailSent, setEmailSent] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const form = useRef();

    async function handleSubmit(event) {
        event.preventDefault();

        const formData = {
            To: 'jerseyjournal@usjersey.com',
            Subject: "Jersey Directory Contact Form Submission",
            Body: `From: ${form.current.from_name.value}\nContact Email: ${form.current.from_email.value}\n\n${form.current.message.value}`
        };

        try {
            const response = await API.createContactEmail(formData);

            if (response?.status === 200) {
                setEmailSent(true);
                setHasError(false);
                form.current.reset();
                setTimeout(() => setEmailSent(false), 5000);
            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            console.error('Send Email Error:', error.response?.data || error.message);
            setEmailSent(false);
            setHasError(true);
            setErrorMessage(error.response?.data?.Error || 'Failed to send email. Please check your connection and try again.');
            setTimeout(() => setHasError(false), 5000);
        }
    }

    return (
        <div className='contactform-container'>
            <Form ref={form} onSubmit={handleSubmit} id='Contact-Us-Form'>
                <Row>
                    <Col>
                        <h2>Send Us A Message</h2>
                        <div className='contactform-seperator'></div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Control
                            className='contactform-control'
                            size='lg'
                            type='text'
                            name='from_name'
                            placeholder='Your Name'
                            required
                        />
                    </Col>
                    <Col>
                        <Form.Control
                            className='contactform-control'
                            size='lg'
                            type='email'
                            name='from_email'
                            placeholder='Your Email'
                            required
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Control
                            className='contactform-control'
                            size='lg'
                            as='textarea'
                            rows={7}
                            name='message'
                            placeholder='Write Your Message Here...'
                            required
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button className='contactform-button' type="submit">
                            Submit
                        </Button>
                    </Col>
                </Row>
                {emailSent && (
                    <Alert variant='success' onClose={() => setEmailSent(false)} dismissible>
                        Contact email successfully sent!
                    </Alert>
                )}
                {hasError && (
                    <Alert variant='danger' onClose={() => setHasError(false)} dismissible>
                        {errorMessage}
                    </Alert>
                )}
            </Form>
        </div>
    );
}

export default ContactForm;